import { TransactionBuilder } from '@orca-so/common-sdk'
import { type TransactionBuilder as EscrowTransactionBuilder } from '@renec-foundation/escrow-sdk/node_modules/@orca-so/common-sdk'
import { Keypair, Transaction } from '@solana/web3.js'
import { useCallback } from 'react'

import { isChainSolana } from '@/constants/index'
import { DemonWalletAdapter,useConnection, useWallet } from '@/wallet/adapter'

const useGaslessHandling = () => {
  const { connection } = useConnection()
  const { wallet, publicKey } = useWallet()

  return useCallback(
    async (tx: TransactionBuilder | EscrowTransactionBuilder) => {
      if (isChainSolana()) return await tx.buildAndExecute()

      const { instructions, cleanupInstructions, signers } = tx.compressIx(true)

      const transaction = new Transaction()

      for (const ix of instructions) {
        transaction.add(ix)
      }
      for (const cIx of cleanupInstructions) {
        transaction.add(cIx)
      }

      transaction.feePayer = publicKey ?? undefined
      transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash

      for (const s of signers) {
        transaction.sign(s)
      }

      return await (wallet?.adapter as DemonWalletAdapter).sendTransactionWithSigners(
        transaction,
        connection,
        signers as Keypair[],
      )
    },
    [connection, wallet, publicKey],
  )
}

export default useGaslessHandling
